import styled from 'styled-components'
import MttGrid from '../Material/MttGrid/MttGrid'
import MttButton from '../Material/MttButton/MttButton'

import { Grid, Typography } from '@material-ui/core'

export const ContainerDialog = styled(MttGrid)<{ colorHeader?: string }>`
  width: 55vw;
  height: 100%;

  padding: 8px 16px;
`

export const ContainerHeader = styled(MttGrid)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ModalTitle = styled(Typography).attrs({
  variant: 'h6',
})`
  color: #0e103b;
`

export const SelectedBlocks = styled(Grid)`
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;

  span {
    opacity: 0.5;
    font-weight: 600;
  }
`

export const FieldContainer = styled(Grid)`
  padding: 5px 0;
  width: 100%;

  .MuiInputBase-input {
    padding: 16px;
    border: solid 1px rgba(0, 0, 0, 0.1);
  }

  .MuiInputBase-input::-webkit-input-placeholder {
    opacity: 0.65;
    font-weight: 500;
  }

  .MuiInput-underline:before {
    display: none;
  }
`

export const ButtonContainer = styled(Grid)`
  padding: 16px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

export const Button = styled(MttButton)`
  height: 50px;
`
